module.exports = __webpack_public_path__ + "static/media/stockhausen_nowald_11.f2ffb283.jpeg";